import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '~/hooks/auth';

import AuthLayout from '~/pages/_layouts/auth';
import DefaultLayout from '~/pages/_layouts/default';

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const { user } = useAuth();

  const Layout = user ? DefaultLayout : AuthLayout;

  if (!user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return <Layout>{children}</Layout>;
};

const PublicRoute = ({ children }) => {
  const location = useLocation();
  const { user } = useAuth();

  const Layout = user ? DefaultLayout : AuthLayout;

  function getRedirectPath() {
    const pathParts = location.pathname.split('/');

    if (pathParts[1] === 'musica-registrada') {
      const keyMusic = pathParts[2];
      return `/dashboard/musica-registrada/${keyMusic}`;
    }
    if (pathParts[1] === 'validacao') {
      const hashAcordeon = pathParts[4];
      return `/dashboard/validacao/registro/certificado/${hashAcordeon}`;
    }
    return '/dashboard/inicio/resumo';
  }

  if (user) {
    return <Navigate to={getRedirectPath()} state={{ from: location }} replace />;
  }

  return <Layout>{children}</Layout>;
};

export { PrivateRoute, PublicRoute };
